import { Card } from "antd";
import { Pie, PieChart, ResponsiveContainer, Sector, Tooltip } from "recharts";
import { percentFormatter } from "../../helpers/common";
import { getDateRangeTitles } from "../../helpers/dayjsSetup";

const renderPieShape = (props, index) => <Sector key={`sector-${index}`} {...props} fill={props.color} stroke="none" />;

const COLORS = ["#03A6A6", "#0D92F4", "#F39C12", "#8E44AD", "#E74C3C"];

export default function OriginSummary({ data }) {
    const dateRangeTitles = getDateRangeTitles();
    const chartData = data.map((item, index) => ({ ...item, color: COLORS[index % COLORS.length] }));
    const total = chartData?.reduce((acc, item) => acc + item.count, 0);
    return (
        <Card className="shadow-sm rounded-xl h-full">
            <div className="flex justify-between items-baseline">
                <span>
                    <span className="flex items-center gap-2 text-[18px] font-semibold" title="Count of collected containers">
                        Origin Summary
                    </span>
                    <span className="text-[12px] text-gray-500" title={dateRangeTitles?.last12Months}>
                        Last 12 months
                    </span>
                </span>
            </div>
            <div className="w-full flex justify-center">
                <div className="w-full max-w-[212px] aspect-square">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Tooltip />
                            <Pie
                                data={chartData}
                                dataKey="count"
                                nameKey="countryName"
                                innerRadius="50"
                                outerRadius="80"
                                paddingAngle={2}
                                shape={renderPieShape}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
            <div className="space-y-2">
                {chartData?.map(item => {
                    const ratio = total > 0 ? item?.count / total : 0;
                    return (
                        <div key={item?.countryName} className="flex justify-between items-center text-sm">
                            <div className="flex items-center gap-2">
                                <span className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: item?.color }} />
                                <span className="text-gray-600">
                                    {item?.countryName}
                                </span>
                            </div>
                            <div className="text-gray-800 font-medium">
                                {item?.count}
                                <span className="text-gray-400 ml-1">
                                    ({percentFormatter.format(ratio)})
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Card>
    );
}